import { render, staticRenderFns } from "./costAddView.vue?vue&type=template&id=851263da&scoped=true&"
import script from "./costAddView.vue?vue&type=script&lang=js&"
export * from "./costAddView.vue?vue&type=script&lang=js&"
import style0 from "./costAddView.vue?vue&type=style&index=0&id=851263da&scoped=true&lang=css&"
import style1 from "./costAddView.vue?vue&type=style&index=1&id=851263da&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851263da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851263da')) {
      api.createRecord('851263da', component.options)
    } else {
      api.reload('851263da', component.options)
    }
    module.hot.accept("./costAddView.vue?vue&type=template&id=851263da&scoped=true&", function () {
      api.rerender('851263da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/costAddView.vue"
export default component.exports